export default {
    backendUrl: "https://dev.hermes.mhr.re"
    backendMediaUrl: "https://dev.hermes.mhr.re/media/"
    authApiUrl: "https://dev.hermes.mhr.re/auth/login/"
    authApiUrlLogout: "https://dev.hermes.mhr.re/auth/logout/"
    graphqlApiUrl: "https://dev.hermes.mhr.re/graphql/"
    websocketUrl: "wss://dev.hermes.mhr.re/ws/models/"
    etherpadUrl: 'https://dev.hermes.mhr.re/pad/p/'
    review_export_data_url: 'https://dev.hermes.mhr.re/admin/review/export/'
}

